import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_ALL_SONG_LIST,
  GET_SONG_LIST,
} from 'shared/constants/ActionTypes';
import Api from '../../@crema/services/auth/jwt-auth/jwt-api';

export const songSearch = (values, page, per_page) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    console.log('values', values);
    Api.get(`/repertory`, {
      params: {query: values.query, type: values.type, page, per_page},
    })
      .then((response) => {
        if (response.status === 200 && response.data.status === 'success') {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_SONG_LIST, payload: response.data.result});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};

export const getSongList = () => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    Api.get(`/repertory/all`)
      .then((response) => {
        if (response.status === 200 && response.data.status === 'success') {
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_ALL_SONG_LIST, payload: response.data.result});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error.message});
      });
  };
};
